<div class="preload preload-container" *ngIf="isLoading">
  <div class="middle"></div>
</div>
